import { getCookie } from 'core/services';
import { TypesUser } from 'redux/actions/user/type';
import { sendDataLayer } from 'utils/TagManager';
import { getStorageUserId } from 'utils/storage';
import { EventName, findFormNameByField } from './findFormNameByFields';
import {
  GTM_LABEL_LOAN_REPEAT_FIRST_LOAN,
  GTM_LABEL_LOAN_REPEAT_LOAN,
  GTM_LABEL_SIGN_UP,
  GTM_LABEL_SKIP,
} from './gtmLabel';
import { TypesUserApplication } from 'redux/actions/userApplication/type';
import { setDayDate } from 'utils/functions';
import {
  getIsApplicationApproved,
  getIsFirstLoan,
  getIsMoneyOnWaySelector,
  getIsMoratoriumSelector,
  getIsRejectedWithoutMoratoriumSelector,
  getIsRepeatFirstLoan,
  getIsRepeatLoan,
  getIsSignAgreementWithZoopOneCompleted,
} from 'redux/selectors';

interface StoreAction {
  type: string;
  payload: any;
  meta: {
    arg: any;
    requestId: string;
    requestStatus: string;
  };
  data: any;
  values: any;
}

export const get_ga_SessionId = () => {
  let match = document.cookie.match('(?:^|;)\\s*_ga_8R2RFDJ6GG=([^;]*)');
  return match ? match[1].split('.')[2] : null;
};

export const get_ga_ClientId = () => {
  const clientId = getCookie('_ga');
  const clientIdSplit = clientId && clientId.split('.');
  return clientIdSplit ? `${clientIdSplit[2]}.${clientIdSplit[3]}` : null;
};

export const sendActionToGtm = (action: StoreAction, store: any): void => {
  const res = action.type.split('_').pop();

  switch (res) {
    case 'SUCCESS':
      _sendSuccessActionToGtm(action, store);
      break;
    default:
  }
};

const _sendSuccessActionToGtm = (action: StoreAction, store: any): void => {
  const state = store.getState();
  const UID = getStorageUserId();
  const applicationId = state.userApplications?.applicationActive?.id;

  const isRepeatLoan = getIsRepeatLoan(state);
  const isRepeatFirstLoan = getIsRepeatFirstLoan(state);
  const isFirstLoan = getIsFirstLoan(state);

  const moratorium_till = state.user.userInfo?.moratorium_till;
  const moro = new Date(moratorium_till) > setDayDate(60);
  const isMoneyOnWay = getIsMoneyOnWaySelector(state);
  const isLeavePendingOrSigning = localStorage.getItem('1') !== null;
  const isSignAgreementWithZoopOneCompleted = getIsSignAgreementWithZoopOneCompleted(state);

  switch (true) {
    case isLeavePendingOrSigning: {
      if (getIsMoratoriumSelector(state)) {
        sendDataLayer(
          EventName.decision_application,
          isRepeatFirstLoan
            ? GTM_LABEL_LOAN_REPEAT_FIRST_LOAN
            : isRepeatLoan
            ? GTM_LABEL_LOAN_REPEAT_LOAN
            : GTM_LABEL_SIGN_UP,
          moro ? 'rejected_hard' : 'rejected_with_moratorium',
          UID,
          applicationId
        );
        localStorage.removeItem('1');
        break;
      }

      if (getIsRejectedWithoutMoratoriumSelector(state)) {
        sendDataLayer(
          EventName.decision_application,
          isRepeatFirstLoan
            ? GTM_LABEL_LOAN_REPEAT_FIRST_LOAN
            : isRepeatLoan
            ? GTM_LABEL_LOAN_REPEAT_LOAN
            : GTM_LABEL_SIGN_UP,
          'rejected_without_moratorium',
          UID,
          applicationId
        );
        localStorage.removeItem('1');
        break;
      }

      if (getIsApplicationApproved(state)) {
        sendDataLayer(
          EventName.decision_application,
          isRepeatFirstLoan
            ? GTM_LABEL_LOAN_REPEAT_FIRST_LOAN
            : isRepeatLoan
            ? GTM_LABEL_LOAN_REPEAT_LOAN
            : GTM_LABEL_SIGN_UP,
          'approved',
          UID,
          applicationId
        );
        localStorage.removeItem('1');
        break;
      }

      if (isMoneyOnWay && isSignAgreementWithZoopOneCompleted) {
        sendDataLayer(
          EventName.sign_loan_agreement_aadhaar_success,
          isRepeatFirstLoan ? GTM_LABEL_LOAN_REPEAT_FIRST_LOAN : GTM_LABEL_SIGN_UP,
          '',
          UID,
          applicationId
        );
        localStorage.removeItem('1');
        localStorage.removeItem('aadhaar_start');
        break;
      }
      break;
    }
    default:
      break;
  }

  switch (action.type) {
    case `${TypesUser.CREATE_USER_SUCCESS}`: {
      sendDataLayer(EventName.phone_number, GTM_LABEL_SIGN_UP, 'sms_code', UID, '');
      break;
    }

    case `${TypesUser.PATCH_USER_SUCCESS}`: {
      for (const key in action.values) {
        const event = findFormNameByField(key);
        if (event) return sendDataLayer(event, GTM_LABEL_SIGN_UP, '', UID, '');
      }
      break;
    }

    case `${TypesUserApplication.POST_CREATE_APPLICATION_SUCCESS}`: {
      if (isRepeatFirstLoan || localStorage.getItem('isRepeatFirstLoan')) {
        sendDataLayer(
          EventName.confirmation_conditions,
          GTM_LABEL_LOAN_REPEAT_FIRST_LOAN,
          '',
          UID,
          applicationId
        );
        sendDataLayer(
          EventName.decision_application,
          GTM_LABEL_LOAN_REPEAT_FIRST_LOAN,
          'pending_application',
          UID,
          applicationId
        );
        break;
      }

      if (isRepeatLoan) {
        sendDataLayer(
          EventName.confirmation_conditions,
          GTM_LABEL_LOAN_REPEAT_LOAN,
          '',
          UID,
          applicationId
        );
        sendDataLayer(
          EventName.decision_application,
          GTM_LABEL_LOAN_REPEAT_LOAN,
          'pending_application',
          UID,
          applicationId
        );
        break;
      }

      if (isFirstLoan) {
        sendDataLayer(EventName.confirmation_conditions, GTM_LABEL_SIGN_UP, '', UID, applicationId);
        sendDataLayer(
          EventName.decision_application,
          GTM_LABEL_SIGN_UP,
          'pending_application',
          UID,
          applicationId
        );
        break;
      }

      break;
    }

    case `${TypesUserApplication.POST_SKIP_PAYMENT_SUBSCRIPTION_SUCCESS}`: {
      sendDataLayer(EventName.auto_debit, GTM_LABEL_SKIP, '', UID, applicationId, '');
      break;
    }

    default:
      break;
  }
};
